/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByUserKind = (typeof GroupByUserKind)[keyof typeof GroupByUserKind];

export const GroupByUserKind = {
  user: 'user',
} as const;
